import { useNavigate } from "react-router-dom";

import { ArrowLeftIcon } from "lucide-react";

import { styled } from "simplydo/react/styled";
import { Button } from "simplydo/react/ui/button";
import { Card, CardContent } from "simplydo/react/ui/card";
import { H2 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";

const ErrorDiv = styled.div<{ $padding?: string | number }>`
  width: 100vw;
  height: 100vh;
  padding: ${(props) => (props.$padding ? props.$padding : "10px")};
  .centerDiv {
    text-align: center;
  }
`;

type ErrorScreenProps = {
  setError: (found: boolean) => void;
  padding?: string | number;
};

const ErrorScreen = ({ setError, padding }: ErrorScreenProps) => {
  const navigate = useNavigate();

  return (
    <ErrorDiv $padding={padding}>
      <div className="centerDiv">
        <Card fluid placeholder>
          <CardContent>
            <H2>
              Sorry, we are experiencing a problem with this part of the
              platform
            </H2>
            <p>An automated report of your issue has been submitted.</p>
            <p style={{ fontWeight: "bold", marginTop: 20, marginBottom: 20 }}>
              Please refresh the page or return to the previous page. If the
              issue continues, please contact our{" "}
              <a href="mailto:support@simplydo.co.uk?subject=Platform%20Problem">
                support.
              </a>
            </p>
            <Button
              className="buttonClass"
              size="medium"
              onClick={() => {
                setError(false);
                navigate(-1);
              }}
              style={{ maxWidth: "fit-content" }}
            >
              <Icon icon={ArrowLeftIcon} />
              Return to previous page
            </Button>
          </CardContent>
        </Card>
      </div>
    </ErrorDiv>
  );
};

export default ErrorScreen;
